import xs from "xstream"
import * as $ from "jquery"

import {dumper, nopListener} from "../utils"
import { button, div, h5, VNode } from "@cycle/dom"
import isolate from "@cycle/isolate"

const _modalTempl = id => msg => `
<div id="${id}" class="modal" style="display:block">\
	<div class="modal fade" tabindex="-1" style="display:block">\
		<div class="modal-dialog modal-sm">\
			<div class="modal-content">\
				<div class="modal-header">\
					<button type="button" class="close">\
						<span>&times;</span>\
					</button>\
				</div>\
				<div class="modal-body">${msg}</div>\
				<div class="modal-footer">\
					<button type="button" class="btn btn-default">Close</button>\
				</div>\
			</div>\
		</div>\
	</div>\
	<div class="modal-backdrop fade"></div>\
</div>
`
// export const makeMessageDialogDriver = (id = "msgDlg") => {
// 	const modalTempl = _modalTempl(id)
// 	const showDialog = (msg) => {
// 		if ($(`#${id}`).length !== 0) {
// 			$(`#${id}`).remove()
// 		}
// 		$('#app').append(modalTempl(msg))
// 		$(`#${id} button`).off().on('click', e => {
// 			$(`#${id}`).remove()
// 		})
// 		setTimeout( () => {
// 			$(`#${id} > div`).toggleClass("in", true)
// 		},10)
// 	}
// 	return sink$ => sink$.map(showDialog).addListener(nopListener("messageDialog"))
// }
const view = (msg: string | null) => {
  const show = msg ? ".show" : ""
  const display = msg ? "block" : "none"
  // const display = "block"
  return div([
    div(`.modal.fade${show}`, { style: { display } }, [
      div(".modal-dialog", [
        div(".modal-content", [
          div(".modal-header", [
            h5(".modal-title", [""]),
            button(".btn-close", [""]),
          ]),
          div(".modal-body", [msg]),
          div(".modal-footer", [button(".btn.btnOK.btn-danger", ["OK"])]),
        ]),
      ]),
    ]),
    div(`.modal-backdrop.fade${show}`, { style: { display } }),
  ])
}
const _ModalDialog = (sources: any) => {
  const msg$ = sources.MSG.startWith(null)
  const close$ = sources.DOM.select(".btn-close, .btnOK").events("click").mapTo(null)

  const view$ = xs.merge(msg$, close$).map(view) as xs<VNode>

  return {
    DOM: view$,
  }
}
export const ModalDialog = isolate(_ModalDialog)

export const makeMessageDialogDriver = (id = "msgDlg") => {
  const msg$ = xs.create()
	return sink$ => {
    sink$
      .map(msg => {
        msg$.shamefullySendNext(msg)
        return msg
      })
      .addListener(dumper("messageDialog"))
    return msg$
  }
}